import React from 'react';
import './NotFoundPage.css';
import Gif404 from "../images/404.svg";

const NotFoundPage: React.FC = () => {
  return (
    <div className="not-found-page">
      <h1>404 - Page Not Found</h1>
      <img src={Gif404} alt="Dogs and Cats" />
      <p>It looks like this page went on a walk with our dogs and cats!</p>
    </div>
  );
};

export default NotFoundPage;
